export enum SubtabAgeRestrictErrorType {
  /**
   * 로그인 전
   */
  BeforeLogin = 'BeforeLogin',
  /**
   * 미인증 유저
   */
  NotAuthenticatedUser = 'NotAuthenticatedUser',
  /**
   * 인증결과 19세 미만
   */
  Under19 = 'Under19',
}
